import React, { lazy } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

const MessageCenterPage = lazy(() => import("../../container/pages/messenger/index"));

function MessagesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}`} component={MessageCenterPage} />
    </Switch>
  );
}

export default MessagesRoute;
